export const LOGIN = 'Login';
export const LOGIN_SUCCESS = 'Login.Success';



// WEBPACK FOOTER //
// ./src/Types/User.js